import { useMemo } from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { createTheme, StyledEngineProvider, ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import palette from "./palette";

export default function ThemeProvider({ children }) {
    const themeOptions = useMemo(
        () => ({
            palette: palette("light"),
            typography: {
                fontFamily: "'Inter', 'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif",
                h1: { fontWeight: 800 },
                h2: { fontWeight: 800 },
                h3: { fontWeight: 800 },
                h4: { fontWeight: 700 },
                h5: { fontWeight: 700 },
                h6: { fontWeight: 700 },
            },
            shape: { borderRadius: 8 },
        }),
        []
    );

    const theme = createTheme(themeOptions);

    return (
        <StyledEngineProvider injectFirst>
            <MUIThemeProvider theme={theme}>
                <CssBaseline />
                <GlobalStyles
                    styles={{
                        "*": { margin: 0, padding: 0, boxSizing: "border-box" },
                        html: { scrollBehavior: "smooth" },
                        body: { overflowX: "hidden" },
                    }}
                />
                {children}
            </MUIThemeProvider>
        </StyledEngineProvider>
    );
}
